export default function changeLanguageInUrl(
  newLang: string,
  currentUrl?: string,
): string {
  const url = new URL(currentUrl ?? window.location.href);
  const segments = url.pathname.split('/').filter(Boolean);

  if (segments.length > 0) {
    segments[0] = newLang;
  } else {
    segments.push(newLang);
  }

  url.pathname = `/${segments.join('/')}`;

  return url.toString();
}
